export default __webpack_public_path__ + "static/media/logo-tsd.f48e92aa.svg";